import { FormattedMessage, injectIntl } from 'react-intl';
import React, { useState, useContext, useEffect, useRef } from 'react';
import { Modal, Form, Input, Row, Col, Button, Tooltip } from 'antd';
import myContext from '@/utils/createContext';
import { InfoCircleOutlined, UserOutlined } from '@ant-design/icons';
import _ from 'lodash';
import { gtag } from '@/utils'
import FloatLabel from '@/components/H5PC/Form/FloatLabel/index.js';
import allRegex from '@/components/allRegex.js';

function Email(props) {
  const intl = props.intl;
  const { formatMessage } = intl;
  const { form, cashierData, showDomain, initData } = useContext(myContext);
  const { email } = cashierData || initData;
  const emailRef = useRef();
  const onBlurCardEmail = async function(e) {
    gtag(`${showDomain}支付页面`, [new Date() + '输入邮箱']);
    gtag(`${showDomain}支付页面`, ['输入邮箱']);
    showDomain ? gtag(`定制支付页面`, ['输入邮箱']):'';
  };

  const paymentMethod = localStorage.getItem('paymentMethod');

  return (
    <div className="h5-email" style={{ display: email && paymentMethod != 'afterpay' && paymentMethod != 'pez' && paymentMethod != 'kon' && paymentMethod != 'kba'? 'none' : 'block' }}>
      <div className="h5-email-suffix">
        <Tooltip
          // title="In case we need to contact you about your order."
          title={formatMessage({ id: 'ga-checkout.email-tips' })}
          placement="rightBottom"
          trigger="click"
        >
          <InfoCircleOutlined style={{ color: '#666666', fontSize: '20px' }} />
        </Tooltip>
      </div>
      <FloatLabel
        form={form}
        name="email"
        cref={emailRef}
        // label="Email"
        label={formatMessage({
          id: 'ga-checkout.email',
        })}
        rules={[
          {
            required: true,
            // message: `Email is required.`,
            message: formatMessage({
              id: 'ga-checkout.placeholder-email-address',
            }),
          },
          {
            pattern: allRegex.emailReg,
            // message: 'Please enter correct email address.',
            message: formatMessage({
              id: 'ga-checkout.placeholder-correct-email-address',
            }),
          },
        ]}
      >
        <Input size="large" maxLength={64} style={{ paddingRight: '40px' }} onBlur = { onBlurCardEmail } />
      </FloatLabel>
    </div>
  );
}

export default injectIntl(Email);
